// src/App.js
import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Projects from './components/Projects';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Experience from './components/Experience';
import AdPopup from './components/AdPopup';  // import our popup
import './App.css';
import AISection from './components/AISection';
import TechStack from './components/TechStack';
import Testimonials from './components/Testimonials';
import Blog from './components/Blog';
import Community from './components/Community';

function App() {
  return (
    <div className="App">
      <Navbar />
      <Hero />
      <AdPopup />
      <About />
      <Services />
      <AISection />
      <Experience />
      <Projects />
      <TechStack />
<Testimonials />
<Blog />
<Community />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
